import { useContext, useState } from 'react';
import ModalContext from '../context/ModalContext';

const useModal = (name) => {
	const { open, setOpen, isOpen } = useContext(ModalContext);
	const [nameOpen] = useState(name);

	return {
		open: open[name],
		setOpen: (data) => {
			console.log('open----: ', data);
			setOpen(nameOpen, { name, ...open[name], ...data });
		},
		setClose: (options) => {
			setOpen(nameOpen, false, options?.onClose);
		},
	};
};

export default useModal;
